import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

function BasicDateRangePicker({onDateChange, noHelperText, boxsize, helperTextValue}) {
  const [value, setValue] = React.useState([dayjs().startOf('year'), dayjs()]);
  if(!helperTextValue){
    helperTextValue = 'Created On'
  }
  if(noHelperText){
    helperTextValue = ''
  }

  const inputWidth = 150;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <DatePicker
          label={helperTextValue || 'From Date'}
          value={value?.[0] ?? null}
          onChange={(newStart) => {
            const next = [newStart, value?.[1] ?? null];
            setValue(next);
            const startDate = next?.[0]?.toDate ? next[0].toDate() : null;
            const endDate = next?.[1]?.toDate ? next[1].toDate() : null;
            onDateChange([startDate, endDate]);
          }}
          slotProps={{
            textField: {
              size: boxsize || 'small',
              fullWidth: false,
              helperText: null,
              FormHelperTextProps: { sx: { display: 'none' } },
              sx: {
                width: inputWidth,
                '& .MuiInputBase-root': {
                  bgcolor: 'background.paper'
                }
              }
            }
          }}
        />
        <Typography variant="body2" sx={{ whiteSpace: 'nowrap', color: 'text.secondary', px: 0.25 }}>
          To
        </Typography>
        <DatePicker
          label="To Date"
          value={value?.[1] ?? null}
          onChange={(newEnd) => {
            const next = [value?.[0] ?? null, newEnd];
            setValue(next);
            const startDate = next?.[0]?.toDate ? next[0].toDate() : null;
            const endDate = next?.[1]?.toDate ? next[1].toDate() : null;
            onDateChange([startDate, endDate]);
          }}
          slotProps={{
            textField: {
              size: boxsize || 'small',
              fullWidth: false,
              helperText: null,
              FormHelperTextProps: { sx: { display: 'none' } },
              sx: {
                width: inputWidth,
                '& .MuiInputBase-root': {
                  bgcolor: 'background.paper'
                }
              }
            }
          }}
        />
      </Box>
    </LocalizationProvider>
  );
}
BasicDateRangePicker.propTypes = {
  onDateChange: PropTypes.func,
  boxsize: PropTypes.string
};

export default BasicDateRangePicker
